(function() {
    'use strict';

    angular.module('product')
        .controller('PackageListController', PackageListController);

    PackageListController.$inject = ['$state', 'packageDataSrvc', 'packageSrvc', 'notificationSrvc', 'lodashService', 'packageMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'packagePermissionsConst', 'filterQuerySrvc', 'checkModelPermissionsSrvc', 'inpostLockerLimitPermissionsConst'];

    function PackageListController($state, packageDataSrvc, packageSrvc, notificationSrvc, lodashService, packageMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, packagePermissionsConst, filterQuerySrvc, checkModelPermissionsSrvc, inpostLockerLimitPermissionsConst) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.packageRows = [];
        self.packageCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Maksymalna waga [kg]',
            value: 'max_weight',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'W x H x L [cm]',
            value: 'width&height&length',
            type: 'join',
            separator: ' x ',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = packagePermissionsConst;
        self.searchQuery = {
            name: null,
            max_weight: null,
            'width&height&length': null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.canViewInpostLockerLimit = canViewInpostLockerLimit;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getPackages();
        }

        function getPackages(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    max_weight: self.searchQuery.max_weight,
                    size: self.searchQuery['width&height&length'],
                    ordering: self.searchQuery.ordering
                };
            }
            return packageDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.packageRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getPackages);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.package.create');
        }

        function onEdit(row) {
            $state.go('layout.package.update', { pk: row.pk });
        }

        function onDelete(row) {
            return packageSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", packageMessagesConst.delete);
                lodashService.remove(self.packageRows, { pk: row.pk });
                return response;
            });
        }

        function canViewInpostLockerLimit() {
            return !checkModelPermissionsSrvc.isDenied(inpostLockerLimitPermissionsConst.view);
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getPackages();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getPackages();
        }
    }
})();
